import { Displaying, Positioning, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import { zIndexes } from "../../../R";

const HeaderContainer = styled.div`
  display: ${Displaying.block};
  position: ${Positioning.sticky};
  top: ${Spacing["0"]};
  z-index: ${zIndexes.one_thousand};
`;

export default HeaderContainer;
